import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';

export const GET_CONTACT_PREFERENCES = graphql(`
  query GetContactPreferences($email: String!) {
    getContactPreferences(email: $email) {
      email
      contactPreferences
      isRegisteredUser
    }
  }
`);

export const useUnsubscribe = (email: string) => {
  const { data, error, loading } = useQuery(GET_CONTACT_PREFERENCES, {
    variables: {
      email,
    },
    skip: !email,
  });

  return {
    contactPreferencesData: data?.getContactPreferences,
    contactPreferencesError: error,
    contactPreferencesLoading: loading,
  };
};
